import React from 'react';
import { useIntl } from 'react-intl';
import { ApiFilterOperation, Evidence } from '@eas/common-web';
import { EsFileState } from '@enums';
import { useInfFiles } from '../inf-files';
import { useColumns } from './inf-file-in-progress-columns';

export const INF_FILES_IN_PROGRESS_IDENTIFIER = 'INF_FILES_IN_PROGRESS';
export const INF_FILES_IN_PROGRESS_VERSION = 9;

export function InfFilesInProgress() {
  const intl = useIntl();
  const columns = useColumns();

  const { evidenceBag } = useInfFiles({
    evidenceProps: {
      identifier: INF_FILES_IN_PROGRESS_IDENTIFIER,
      version: INF_FILES_IN_PROGRESS_VERSION,
      tableProps: {
        columns,
        defaultPreFilters: [
          {
            field: 'state.id',
            operation: ApiFilterOperation.EQ,
            value: EsFileState.IN_PROGRESS,
          },
        ],
        tableName: intl.formatMessage({
          id: 'ES__INF_FILES_IN_PROGRESS__TABLE__TITLE',
          defaultMessage: 'Spisy INF - V řešení',
        }),
      },
      detailProps: {
        toolbarProps: {
          showBtn: (btn) => !['NEW'].includes(btn),
        },
      },
    },
  });

  return <Evidence {...evidenceBag} />;
}
